import React from "react";

import img1 from "../../assets/gallery/img1.jpeg";
import img2 from "../../assets/gallery/img2.jpeg";
import img3 from "../../assets/gallery/img3.jpeg";

import img4 from "../../assets/gallery/img4.jpeg";
import img5 from "../../assets/gallery/img5.jpeg";
import img6 from "../../assets/gallery/img6.jpeg";
import { Helmet } from "react-helmet";

const images = [img1, img2, img3, img4, img5, img6];

function Gallery() {
  return (
    <>
      <Helmet>
        <title>The Best Cab Jaipur – Affordable Taxi, One Way & Outstation Services</title>
        <meta
          name="description"
          content="Book reliable and affordable cab services in Jaipur for one-way, round trips, and outstation travel. Explore Rajasthan’s top destinations with our trusted taxi service and tour packages."
        />
        <meta
          name="keywords"
          content="Jaipur cab service, one way taxi, round trip taxi, outstation travel, affordable taxi, Rajasthan tours, taxi booking Jaipur"
        />
        <meta name="author" content="The Best Cab Jaipur" />
      </Helmet>

      <section className="py-16 px-12 bg-white">
        <div className="text-center mb-10">
          <h2 className="text-4xl font-semibold text-gray-800">
            Captured Journeys - From Destinations to Memories
          </h2>
          <p className="text-gray-600 mt-3">
            Enjoy your vacation with family, friends & Loved Ones!
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 justify-center items-center">
          {images.map((img, index) => (
            <div key={index} className="overflow-hidden shadow-lg">
              <img
                src={img}
                alt={`Tour Spot ${index + 1}`}
                className="w-full h-[250px] object-cover transition-transform duration-300 hover:scale-105"
              />
            </div>
          ))}
        </div>
      </section>
    </>
  );
}

export default Gallery;